module.exports = __webpack_public_path__ + "img/Redshift.502acc7b.png";